export const blockDetailTheme = {
  divider: {
    bg: 'palette.surface.4',
    height: '1px',
    verticalGap: '16px',
  },
};
